import React, { useState } from 'react';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../css/Message.css';
import '../css/Home.css'; // Ensure the correct path to your CSS file
import Footer from '../pages/Footer';


function Message() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const clearForm = () => {
    setName('');
    setEmail('');
    setMessage('');
  };

  const sendNotifySuccess = () => {
    toast.success('Message sent successfully!', {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
    });

    // Clear the input fields after showing the notification
    clearForm();
  };

  const notifyError = () => {
    toast.error('Message sending failed!', {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
    });

    // Clear the input fields after showing the notification
    clearForm();
  };

  return (
    
    <div className="message-container">
      <div className="message-content">
        <div className="message-left">
          <div className="message-address details">
            <FaMapMarkerAlt />
            <div className="message-topic">Address</div>
            <div className="message-text-one">Bashundhara Residential Area</div>
            <div className="message-text-two">Abdur Sadek Road, Bashundhara, Dhaka</div>
          </div>
          <div className="message-phone details">
            <FaPhoneAlt />
            <div className="message-topic">Phone</div>
            <div className="message-text-one">+880 969630 9016</div>
            <div className="message-text-two">+880 175430 9016</div>
          </div>
          <div className="message-email details">
            <FaEnvelope />
            <div className="message-topic">Email</div>
            <div className="message-text-one">zahid.imx@gmail.com</div>
            <div className="message-text-two">2022504@iub.edu.bd</div>
          </div>
        </div>
        <div className="message-right">
          <div className="message-topic-text">Send us a message</div>
          <p>
            If you have any recommendation for us or any types of queries related to our Project, you can send me a message from here. It's my pleasure to help you.
          </p>
          <form>
            <div className="message-input-box">
              <input
                type="text"
                placeholder="Enter your name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="message-input-box">
              <input
                type="text"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="message-input-box message-box">
              <textarea
                placeholder="Enter your message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              ></textarea>
            </div>
            <div className="message-button">
              <input type="button" value="Send Now" onClick={sendNotifySuccess} />

            </div>
          </form>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        style={{ marginTop: '90px' }}
      />
            <Footer />
    </div>
  );
}

export default Message;
